// extracted by mini-css-extract-plugin
export default {"btn":"LinkWithIcon_btn__6ufTy","text":"LinkWithIcon_text__x5Yqd","icon":"LinkWithIcon_icon__Z8BP0","active":"LinkWithIcon_active__bPvA5"};